var _path, _path2, _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatchingbig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 35,
    viewBox: "0 0 28 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.1422C25 15.0234 23.2465 18.5925 21.3333 22.5151C18.8085 27.6918 15.788 33.057 14 34.0405C12.1659 32.6953 9.2133 27.7384 6.66667 22.5151C4.84955 18.7881 3 14.9253 3 12.1422C3 5.45864 7.92487 0.0405273 14 0.0405273C20.0751 0.0405273 25 5.45864 25 12.1422Z",
    fill: "#254E9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.1422C25 15.0234 23.2465 18.5925 21.3333 22.5151C18.8085 27.6918 15.788 33.057 14 34.0405C12.1659 32.6953 9.2133 27.7384 6.66667 22.5151C4.84955 18.7881 3 14.9253 3 12.1422C3 5.45864 7.92487 0.0405273 14 0.0405273C20.0751 0.0405273 25 5.45864 25 12.1422Z",
    fill: "#254E9C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.0405,
    r: 13,
    fill: "white",
    stroke: "#254E9C",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.0405,
    r: 13,
    fill: "white",
    stroke: "#254E9C",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1229_325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7534 7.53634C18.4031 7.18861 17.9109 6.97119 17.3751 6.97119C16.839 6.97119 16.3472 7.18861 15.9964 7.53634C15.6448 7.88323 15.4252 8.37054 15.4256 8.90098C15.4252 9.43229 15.6448 9.91877 15.9964 10.2656C16.1515 10.4196 16.3356 10.5465 16.5373 10.6421V16.1113C16.5369 16.9281 16.2152 17.6972 15.6311 18.2767C15.0462 18.8545 14.269 19.1735 13.444 19.1735C12.6186 19.1735 11.8419 18.8545 11.257 18.2767C10.6729 17.6972 10.3512 16.9281 10.3508 16.1113C10.3512 15.6523 10.4542 15.2098 10.6486 14.8037C10.9169 14.9865 11.2365 15.1971 11.3557 15.2462C11.4689 15.2936 11.7547 15.2441 11.6458 14.7521C11.5005 14.0982 11.6295 13.297 11.876 12.3113C11.9594 11.9789 11.8594 11.8858 11.6897 11.9222C10.8147 12.0207 9.85728 12.9179 9.69623 13.1891L9.6189 13.2911C9.00109 14.1109 8.6751 15.0859 8.67554 16.1113C8.6751 17.3732 9.17114 18.5589 10.0718 19.4498C10.9716 20.3414 12.1687 20.8326 13.444 20.8326H13.4453C14.7194 20.8326 15.9165 20.3414 16.8163 19.4497C17.7174 18.5589 18.213 17.3732 18.2125 16.1113V10.6413C18.4146 10.5465 18.5983 10.4196 18.7534 10.2657C19.105 9.91877 19.3247 9.43232 19.3242 8.90101C19.3246 8.37054 19.105 7.88323 18.7534 7.53634ZM17.7511 9.27324C17.6524 9.3697 17.5242 9.42723 17.3751 9.42807C17.226 9.42723 17.0974 9.3697 16.9992 9.27324C16.9017 9.17594 16.8436 9.04905 16.8432 8.90098C16.8437 8.75376 16.9018 8.62644 16.9992 8.52873C17.0974 8.4327 17.226 8.3756 17.3751 8.37474C17.5242 8.37558 17.6524 8.4327 17.7511 8.52873C17.8481 8.62644 17.9062 8.75379 17.9067 8.90098C17.9062 9.04905 17.8481 9.17596 17.7511 9.27324Z",
    fill: "#254E9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1229_325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 13.8614,
    fill: "white",
    transform: "translate(7 6.97119)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatchingbig);
export default __webpack_public_path__ + "static/media/catching big.7634c5aeb018499ae382d3b7196f639e.svg";
export { ForwardRef as ReactComponent };